var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDataLossPrevention(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M10.614 10.614q.888 0 1.52-.633.633-.633.633-1.52 0-.89-.632-1.522a2.07 2.07 0 0 0-1.521-.632q-.89 0-1.521.632A2.07 2.07 0 0 0 8.46 8.46q0 .889.633 1.521.633.633 1.52.633m0 4.307a5.2 5.2 0 0 0 2.274-.512 5.4 5.4 0 0 0 1.844-1.453 7.8 7.8 0 0 0-1.978-.942 7.2 7.2 0 0 0-2.14-.324q-1.104 0-2.14.324-1.036.322-1.979.942a5.4 5.4 0 0 0 1.844 1.453 5.2 5.2 0 0 0 2.275.512m0 4.307q-3.608 0-6.11-2.504Q2 14.22 2 10.614q0-3.608 2.503-6.11Q7.008 2 10.613 2q3.608 0 6.111 2.503 2.503 2.505 2.503 6.11a8.3 8.3 0 0 1-.484 2.84 8.8 8.8 0 0 1-1.346 2.437l4.307 4.307q.296.295.296.753 0 .457-.296.754a1.02 1.02 0 0 1-.754.296 1.02 1.02 0 0 1-.753-.296l-4.307-4.307a8.8 8.8 0 0 1-2.436 1.346 8.3 8.3 0 0 1-2.84.485m0-2.154q2.691 0 4.576-1.884 1.884-1.885 1.884-4.576 0-2.692-1.884-4.576-1.885-1.884-4.576-1.885-2.692 0-4.576 1.885-1.884 1.884-1.885 4.576 0 2.691 1.885 4.576 1.884 1.884 4.576 1.884"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataLossPrevention);
export default __webpack_public_path__ + "static/media/data_loss_prevention.64da25baf1603913d1519e1395344c5f.svg";
export { ForwardRef as ReactComponent };